/** Kept identical to StreamErrorCode in web/routes/sseKeepalive.ts and to the
 *  codes emitted by the agent service (chat_engine.py). */
const STREAM_ERROR_MESSAGES: Record<string, string> = {
  llm_timeout:
    'The request took too long and timed out. Try narrowing the question or asking for less at once.',
  llm_unavailable:
    'The model service is temporarily unavailable. Please try again in a moment.',
  tool_error:
    'A tool failed while gathering data, so the answer may be incomplete. Please try again.',
  auth_expired: 'Your session expired. Reload the page and try again.',
  upstream_unreachable: 'Lost the connection to the agent. Please try again.',
  unknown: 'Something went wrong while generating the response. Please try again.',
};

export function getFriendlyErrorMessage(err: any): string {
  // A typed code from the stream is more precise than any string sniffing below.
  const code: unknown = err?.code;
  if (typeof code === 'string' && code in STREAM_ERROR_MESSAGES) {
    return STREAM_ERROR_MESSAGES[code];
  }
  const raw: string = err?.message ?? '';
  if (
    raw.includes('tool_call_id') ||
    raw.includes('tool_calls') ||
    raw.includes('invalid_request_error') ||
    /Error code:\s*\d+/.test(raw)
  ) {
    return 'Something went wrong while processing the response. Please try again.';
  }
  const httpMatch = raw.match(/^HTTP_(\d+):/);
  if (httpMatch) {
    const status = parseInt(httpMatch[1], 10);
    if (status >= 500) return 'The server encountered an error. Please try again in a moment.';
    if (status >= 400) return 'Your request couldn\'t be completed. Please try again.';
  }
  if (raw.length > 0 && !raw.includes('{') && !raw.includes("'type'")) return raw;
  return 'Could not send message. Please try again.';
}
